import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Fonction pour gérer le scroll
    const handleScroll = () => {
      // Si nous avons un hash dans l'URL, laissons le navigateur gérer le scroll
      if (hash) return;

      // Utilisation de requestAnimationFrame pour s'assurer que le DOM est prêt
      requestAnimationFrame(() => {
        // Force un scroll immédiat au début
        window.scrollTo(0, 0);
        
        // Puis applique un scroll smooth pour une meilleure expérience utilisateur
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }, 0);
      });
    };

    handleScroll();

    // Nettoyage
    return () => {
      // Annuler toute animation de scroll en cours si nécessaire
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: window.scrollY,
          left: 0,
          behavior: 'auto'
        });
      }
    };
  }, [pathname, search, hash]); // Déclencher sur tout changement dans l'URL

  return null;
}

export default ScrollToTop;
